(function initialiseQuickSubscription(global) {
  'use strict';

  function matchingLines(cart, item) {
    return (cart.items || []).filter((line) =>
      Number(line.variant_id) === item.id &&
      Number(line.selling_plan_allocation?.selling_plan?.id) === item.selling_plan
    );
  }

  function missingItems(cart, items) {
    return items.filter((item) => {
      const lines = matchingLines(cart, item);
      if (!lines.length) return true;
      // Preserve existing baskets; ask for review if an annual line is inconsistent.
      if (lines.length !== 1 || Number(lines[0].quantity) !== item.quantity) {
        throw new Error('Review existing annual subscription quantities.');
      }
      return false;
    });
  }

  async function prepareCheckout(fetchCart, addItems, items) {
    const missing = missingItems(await fetchCart(), items);
    if (missing.length) await addItems(missing);
    if (missingItems(await fetchCart(), items).length) {
      throw new Error('Both annual subscriptions must be present before checkout.');
    }
  }

  if (typeof module === 'object' && module.exports) {
    module.exports = { missingItems, prepareCheckout };
  }
  if (!global.customElements || global.customElements.get('yfl-quick-subscription')) return;

  global.customElements.define('yfl-quick-subscription', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised || this.dataset.available !== 'true') return;
      this.initialised = true;
      this.button = this.querySelector('button');
      this.labelElement = this.querySelector('[data-quick-label]');
      this.status = this.querySelector('[data-quick-status]');
      this.cartLink = this.querySelector('[data-quick-cart]');
      this.label = this.labelElement.textContent;
      try {
        this.items = JSON.parse(this.querySelector('[data-quick-items]').textContent);
      } catch (_error) {
        return;
      }
      this.button.disabled = false;
      this.button.addEventListener('click', () => this.checkout());
    }

    reset() {
      this.pending = false;
      this.button.disabled = false;
      this.labelElement.textContent = this.label;
      this.removeAttribute('aria-busy');
    }

    async request(url, options = {}) {
      const response = await global.fetch(url, {
        credentials: 'same-origin', cache: 'no-store', ...options,
        headers: { Accept: 'application/json', ...options.headers },
      });
      if (!response.ok) throw new Error('Cart request failed.');
      return response.json();
    }

    async checkout() {
      if (this.pending) return;
      this.pending = true;
      this.button.disabled = true;
      this.labelElement.textContent = this.dataset.loading;
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = '';
      this.cartLink.hidden = true;
      try {
        await prepareCheckout(
          () => this.request(`${this.dataset.cartUrl}.js`),
          (items) => this.request(this.dataset.addUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items }),
          }),
          this.items,
        );
        global.location.assign(this.dataset.checkoutUrl);
      } catch (_error) {
        this.reset();
        this.status.textContent = this.dataset.error;
        this.cartLink.hidden = false;
      }
    }
  });

  global.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    global.document.querySelectorAll('yfl-quick-subscription').forEach((element) => {
      if (element.pending) element.reset();
    });
  });
})(typeof window === 'undefined' ? globalThis : window);
